import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';

@Component({
  selector: 'piqet-angular-new-processing-custom-conversion',
  templateUrl: './new-processing-custom-conversion.component.html',
  styleUrls: ['./new-processing-custom-conversion.component.scss'],
})
export class NewProcessingCustomConversionComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  processingCustomConversionData: any;
  processingCustomConversionForm!: FormGroup;
  processingCustomConversionAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  processingCustomConversionList: any;
  regionList: any;
  regionData: any;
  selectRegion: any;
  setIndicatorData: any;
  indicatorList: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  @Output() saveNewProcessingCustomConversionEvent = new EventEmitter<any>();

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    private administratorService: AdministratorService
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.processingCustomConversionData =
      this.modal?.modalService?.config?.initialState?.['newProcessingCustomConversionData'];
    this.isDisabledDropDown = this.modalLabel == 'Review conversion detail' ? true : false;
    this.indicatorList = this.processingCustomConversionData.indicatiorList;
    this.processingCustomConversionList = this.processingCustomConversionData.energyProcessItems;
    this.regionList = this.processingCustomConversionData.regionItems;
    this.getRegionData();
  }

  ngOnInit(): void {
    const form = [];
    for (let i = 0; i < this.indicatorList.length; i++) {
      form[this.indicatorList[i].name] = new FormControl(
        this.processingCustomConversionData.indicatiorList[i].defaultValue || 0,
        Validators.required
      );
    }
    this.processingCustomConversionForm = new FormGroup(form);
    this.processingCustomConversionAddEditForm = this.formBuilder.group({
      conversion: [
        this.processingCustomConversionData.energyProcessId || null,
        Validators.required,
      ],
      region: [null, Validators.required],
    });
    this.setFormData();
  }

  onClose() {
    this.modal.close();
  }

  onChange(value: any) {
    this.processingCustomConversionAddEditForm.controls['region'].setValue(null);
    if (!!value?.id) {
      this.administratorService
        .GetRegionsForProcessingCustomConversion(value.id)
        .subscribe((data: any) => {
          this.regionData = data.data;
        });
    } else {
      this.regionData = [];
    }
  }

  commonInputSearch(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }
  commonInputSearchForRegion(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  async getRegionData() {
    await this.regionList.map((item: any) => {
      if (item.id == this.processingCustomConversionData.regionId) {
        return (this.selectRegion = item);
      }
    });
  }

  setFormData() {
    this.processingCustomConversionAddEditForm.patchValue({ region: this.selectRegion });
  }

  onSave() {
    this.submitted = true;
    if (
      this.processingCustomConversionAddEditForm.controls['region'].value?.name ==
        '--Select Region-- ' ||
      (this.activatedRoute == 'processing-data-conversion' &&
        !this.processingCustomConversionAddEditForm.controls['region'].value?.name)
    ) {
      return;
    }
    if (
      this.processingCustomConversionAddEditForm.status == 'VALID' &&
      this.processingCustomConversionForm.status == 'VALID'
    ) {
      const entires = Object.entries(this.processingCustomConversionForm.value);
      const resultArray: any = [];
      let i = {};
      const entiresArray = this.processingCustomConversionData.indicatiorList.map(
        (obj: any, index: any) => ({
          ...obj,
          ...entires[index],
        })
      );
      entiresArray.forEach((event: any, index: any) => {
        i = {
          indicatorId: event.indicatorId,
          name: event.name,
          unit: event.unit,
          defaultValue: event[1],
          equivalencyUnits: event.equivalencyUnits,
          multiplier: event.multiplier,
        };
        resultArray.push(i);
      });
      const processingCustomConversionPayload = {
        energyProcessId: this.processingCustomConversionAddEditForm.controls['conversion'].value,
        regionId:
          this.processingCustomConversionAddEditForm.controls['region'].value?.id ||
          this.processingCustomConversionData.regionId,
        organizationId: this.processingCustomConversionData.organizationId,
        indicatiorList: resultArray,
      };
      this.saveNewProcessingCustomConversionEvent.emit(processingCustomConversionPayload);
      this.onClose();
    }
  }
}
